import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

const ThumbContainer = styled.div`
  text-align: center;
`

const StyledImg = styled.img`
  width: 100%;
  max-width: 100%;
  max-height: 40px;
  display: none;

  &--loaded {
    display: initial;
    animation-duration: 1s;
    animation-fill-mode: both;
    animation: fadeIn 1s ease-in 1 forwards;
  }
`

const Thumb = ({ src }) => {
  const imgRef = useRef(null)
  const spinnerRef = useRef(null)

  const onload = e => {
    spinnerRef.current.style.display = 'none'
    imgRef.current.classList.add(`${imgRef.current.classList[0]}--loaded`)
  }

  return (
    <ThumbContainer>
      <span className='is-loading' ref={spinnerRef} />
      <StyledImg src={src} ref={imgRef} onLoad={onload} />
    </ThumbContainer>
  )
}

Thumb.propTypes = {
  src: PropTypes.string.isRequired
}

export default Thumb
